<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="项目ID：" prop="pid1">
                <span>{{model.pid1}}</span>
            </el-form-item>
            <el-form-item label="卡号：" prop="card_code">
                <span>{{model.card_code}}</span>
            </el-form-item>
            <el-form-item label="运营商：" prop="operator">
                <span>{{model.operator}}</span>
            </el-form-item>
            <el-form-item label="流量套餐：" prop="flow_package">
                <span>{{model.flow_package}}</span>
            </el-form-item>
            <el-form-item label="启用状态：" prop="state">
                <span>{{model.state}}</span>
            </el-form-item>
            <el-form-item label="添加人ID：" prop="creator_id">
                <span>{{model.creator_id}}</span>
            </el-form-item>
            <el-form-item label="添加人名称：" prop="creator_name">
                <span>{{model.creator_name}}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="create_time">
                <span>{{model.create_time}}</span>
            </el-form-item>
            <el-form-item label="更新人ID：" prop="update_id">
                <span>{{model.update_id}}</span>
            </el-form-item>
            <el-form-item label="更新人名称：" prop="update_name">
                <span>{{model.update_name}}</span>
            </el-form-item>
            <el-form-item label="更新时间：" prop="update_time">
                <span>{{model.update_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'netCardInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                pid1: '',
                card_code: '',
                operator: '',
                flow_package: '',
                state: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/netcard/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>